import { useState, useEffect } from "react";
import Input from "../Input/Input";
import Button from "../Buttons/Button";
import Dialog from "../Dialog/Dialog";
import { css } from "@emotion/react";
import Loading from "../Loading/Loading";
import InfoIcon from "@/svg/InfoIcon";
import { Body, H6 } from "@/components/Typography";
import { backgroundColor, iconColor, textColor } from "@/constants/colors";
import { mq } from "@/constants/breakpoints";

interface OrgNameDialogProps {
  open: boolean;
  onRequestClose: () => void;
  errorMessage: string;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (orgName: string) => React.FormEventHandler<HTMLFormElement>;
  loading?: boolean;
}

export const OrgNameDialog = ({
  open,
  onRequestClose,
  errorMessage,
  onSubmit,
  loading = false,
}: OrgNameDialogProps) => {
  const [orgName, setOrgName] = useState("");

  useEffect(() => {
    if (open) return;
    const sessionOrgName = sessionStorage.getItem("jw_organization_name");
    setOrgName(sessionOrgName ?? "");
  }, [open]);

  return (
    <Dialog isOpen={open} onRequestClose={onRequestClose}>
      <Loading open={loading} />
      <H6
        css={css`
          font-weight: 400;
          font-size: 24px;
          text-align: center;
        `}
      >
        Please enter the name of your organization
      </H6>
      <form onSubmit={onSubmit(orgName)}>
        <Input
          autoFocus
          required
          value={orgName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setOrgName(e.target.value)
          }
          placeholder="Organization Name"
          errorMessage={errorMessage}
          css={css`
            margin-top: 24px;
          `}
        />

        <div
          css={css`
            padding: 14px 16px;
            border-radius: 10px;
            background: ${backgroundColor};
            margin-top: 20px;
            display: flex;
            align-items: center;
            gap: 12px;

            ${mq["sm"]} {
              padding: 16px;
            }
          `}
        >
          <InfoIcon
            css={css`
              color: ${iconColor};
              flex-shrink: 0;
            `}
          />
          <Body
            css={css`
              font-size: 12px;
              font-weight: 400;
              line-height: 135%;
              color: ${textColor};
              text-align: left;
            `}
          >
            We&apos;ll use this to set up a temporary URL for your website (like{" "}
            <strong>yourorganization.jerseywatch.com</strong>) which you can
            later change to your own custom domain (like
            <strong> www.yourorganization.com</strong>).
          </Body>
        </div>

        <div
          css={css`
            margin-top: 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            ${mq["xs"]} {
              flex-direction: column-reverse;
              gap: 15px;
            }
            ${mq["sm"]} {
              flex-direction: row;
            }
          `}
        >
          <Button
            type="button"
            jwType="light"
            onClick={onRequestClose}
            css={css`
              // min-width: unset;
            `}
          >
            Cancel
          </Button>
          <Button type="submit" jwType="dark" disabled={loading}>
            Create Account
          </Button>
        </div>
      </form>
    </Dialog>
  );
};

export default OrgNameDialog;
